module.exports = __webpack_public_path__ + "static/media/spider-sprite.38549e31.png";


//////////////////
// WEBPACK FOOTER
// ./src/bug-screen/spider-sprite.png
// module id = 776
// module chunks = 0